import { NgModule } from "@angular/core";
import { MachineActivityTrashComponent } from "./trash/machine-activity-trash/machine-activity-trash.component";
import { MachineInfoTrashComponent } from "./trash/machine-info-trash/machine-info-trash.component";
import { MachinePartInfoTrashComponent } from "./trash/machine-part-info-trash/machine-part-info-trash.component";
import { MediumTrashComponent } from "./trash/medium-trash/medium-trash.component";
import { TrashComponent } from "./trash/trash.component";
import { CommonModule } from "@angular/common";
import { DxButtonModule, DxDataGridModule, DxSelectBoxModule, DxSwitchModule, DxTabPanelModule, DxTagBoxModule, DxTextBoxModule } from "devextreme-angular";
import { DxiItemModule } from "devextreme-angular/ui/nested";
import { NgxSpinnerModule } from "ngx-spinner";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuardWithForcedLogin, PipesModule, RoleEnum, RoleGuard } from "acl-cloud-lib";
import { ReactiveFormsModule } from "@angular/forms";

const routes: Routes = [
  {
    path: 'trash',
    component: TrashComponent,
    canActivate: [AuthGuardWithForcedLogin, RoleGuard],
    data: { roles: [RoleEnum.SUPERADMIN], breadcrumb: 'Trash' }
  },
];

@NgModule({
  declarations: [
    TrashComponent,
    MachineActivityTrashComponent,
    MachineInfoTrashComponent,
    MachinePartInfoTrashComponent,
    MediumTrashComponent
  ],
  imports: [
    FontAwesomeModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxButtonModule,
    DxDataGridModule,
    DxiItemModule,
    DxTabPanelModule,
    DxTagBoxModule,
    DxSwitchModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    CommonModule,
    RouterModule.forChild(routes),
    PipesModule
  ]
})
export class AdministrationModule { }
